import type * as XLJS from 'exceljs';
import { parseCellValue } from './index';

export function readRawData(sheet: XLJS.Worksheet) {
  if (sheet.rowCount <= 1) {
    throw new Error('file must not be empty')
  }

  // Read Header
  const head = sheet.getRow(1)
  if (!head) {
    throw new Error('file must not be empty')
  }

  let header: string[] = []
  // @ts-ignore unknwon head.values.length
  // xljs has always reserved the first column as an empty
  for (let i = 1; i < head.values.length; i++) {
    // @ts-ignore
    const item = head.values[i]
    if (!item) {
      throw new Error('failed to read data, there are one or more empty header column')
    }
    header.push(parseCellValue(item).toLowerCase().trim())
  }

  // Reserved column name
  if (header.includes("no") || header.includes("NO") || header.includes("No") || header.includes("nO")) {
    throw new Error('header column "NO" is not allowed')
  }

  // check duplicate header
  if (new Set(header).size !== header.length) {
    throw new Error('header column have to be unique')
  }

  header = ["no", ...header]
  const rawRows = sheet.getRows(2, sheet.rowCount)
  if (!rawRows) {
    throw new Error('file must not be empty')
  }

  const rows: any[] = []
  for (let i = 0; i < 5; i++) {
    if (i > rawRows.length - 1) {
      break
    }

    const temp: any[] = []
    // @ts-ignore unknown type
    const rowValues: any[] = rawRows[i].values
    const rowLength = rowValues.length || 0
    for (let j = 1; j <= rowLength; j++) {
      temp.push(parseCellValue(rowValues[j]))
    }

    if (temp.length > 0) {
      rows.push([i + 1, ...temp])
    }
  }

  return {
    header,
    rows,
  }
}
